import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Typography from "../../atoms/Typography/Typography";

import "./CardBody.scss";

const CardBody = ({ title, paragraph, collection, isCollapsed, layout }) => {
  const titleToShow = title ? <strong>{title}</strong> : null;
  const paragraphToShow = paragraph ? (
    <Typography>
      {titleToShow}
      {paragraph}
    </Typography>
  ) : null;
  const entryListClassName = layout === "2col" ? "cardbody-2colsec" : null;
  const itemPointClassName = layout === "2col" ? "cardbody-2colitem" : null;

  const itemTitleToShow = (title) =>
    title ? (
      <Typography>
        <strong>{title}</strong>
      </Typography>
    ) : null;

  return (
    <div
      className={isCollapsed ? "cardbody cardbody-close" : "cardbody"}
      data-testid="cardbody"
    >
      {paragraphToShow}
      {collection &&
        collection.map((entry, index) => (
          <Fragment key={index}>
            {itemTitleToShow(entry.title)}

            <ul className={entryListClassName}>
              {entry.items &&
                entry.items.map((item) => (
                  <li key={item} className={itemPointClassName}>
                    {item}
                  </li>
                ))}
            </ul>
          </Fragment>
        ))}
    </div>
  );
};

CardBody.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  layout: PropTypes.oneOf(["1col", "2col"]).isRequired,
  title: PropTypes.string,
  paragraph: PropTypes.string,
  collection: PropTypes.arrayOf(
    PropTypes.exact({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.string),
    })
  ),
};

export default CardBody;
